export const STOCK_STATUS_LIST = [
    { id: "OUT_OF_STOCK", label: "outOfStock", value: [null, 0] },
    { id: "LOW_STOCK", label: "lowOnStock", value: [0, 10] },
    { id: "HIGHT_STOCK", label: "highStock", value: [1000, null] },
    { id: "IN_STOCK", label: "inStock", value: [1, null] },
];
